import { FC, HTMLAttributes } from "react";

import { MUIIcon } from ".";

export interface ILabelAttributes extends HTMLAttributes<HTMLLabelElement> {
    icon?: string
    label?: string
    iconClassName?: string
}

export const Label: FC<ILabelAttributes> = ({ label, icon, iconClassName, children, ...props }) => {
    return <>
        <label {...props}>
            {(icon) && <MUIIcon iconName={icon} className={iconClassName} />}
            {label}
            {children}
        </label>
    </>
}